<template>
    <div class=" h-full pt-20 lg:pt-20 mx-auto">
        <div class=" bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden p-4 mt-0 m-2">
            <header>
                <i class="pi pi-user text-3xl m-4 text-[#36a8dd]"></i>
                <span class="text-3xl ">Profile</span>
            </header>
            <div class="relative float-right">
                <img class="h-48 w-auto rounded-full"
                    src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"
                    alt="" />
                <!-- <FileUpload choose-label="Upload" mode="basic" name="demo[]" url="/api/upload" accept="image/*"
                    :maxFileSize="1000000" class="absolute bottom-0 ml-auto mr-auto left-0 right-0 py-0.5 px-2 w-24 bg-[#36a8dd]" /> -->
            </div>
            <div class="ml-8">
                <div class="flex flex-col gap-1 ">
                    <label for="firstname">First name</label>
                    <InputText id="firstname" v-model="user.given_name" class="w-64 border" disabled/>
                </div>
                <div class="flex flex-col gap-1 my-4">
                    <label for="firstname">Family name</label>
                    <InputText id="firstname" v-model="user.family_name" class="w-64 border" disabled/>
                </div>
                <div class="flex flex-col gap-1">
                    <label for="firstname">Email</label>
                    <InputText id="firstname" v-model="user.email" class="w-64 border" disabled/>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang='ts' setup>
import { ref, onMounted } from 'vue'
// import FileUpload from 'primevue/fileupload';
import InputText from 'primevue/inputtext';
import { authStore } from "../store/index";

const auth = authStore();

const user = ref({
    family_name: '',
    given_name: '',
    email:''
})

onMounted(async () => {
    Object.keys(user.value).forEach(key => {
        user.value[key] = auth.user.profile[key]
    });
    
})

</script>